import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function LessonCount(): React.ReactElement {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#lessonCountIcon)">
        <path d="M10.1576 12.4782C9.83724 12.6747 9.42696 12.7829 9.00232 12.7829C8.57769 12.7829 8.1674 12.6747 7.84703 12.4782L2.61663 9.27034C2.61663 9.27034 2.14453 8.98097 2.14453 9.63651C2.14453 10.3809 2.14453 12.6142 2.14453 12.6142C2.14453 12.644 2.14453 12.7934 2.14453 12.8398C2.14453 14.5272 5.21482 16.3463 9.00219 16.3463C12.7896 16.3463 15.8598 14.5272 15.8598 12.8398C15.8598 12.7934 15.8598 12.644 15.8598 12.6142C15.8598 12.6142 15.8598 10.2455 15.8598 9.45591C15.8598 8.92972 15.5242 9.18683 15.5242 9.18683L10.1576 12.4782Z"/>
        <path d="M17.6986 6.71893C18.1005 6.47246 18.1005 6.06912 17.6986 5.82261L9.7307 1.83817C9.32881 1.5917 8.67115 1.5917 8.26925 1.83817L0.301421 5.82261C-0.100474 6.06908 -0.100474 6.47241 0.301421 6.71893L8.26925 11.6057C8.67115 11.8522 9.32881 11.8522 9.7307 11.6057"/>
        <path d="M17.3705 13.9623C17.3705 12.613 17.3705 8.56527 17.3705 8.56527C17.3705 8.56527 17.3743 8.30964 17.2226 8.39405C17.1009 8.46177 16.8027 8.62802 16.6976 8.71943C16.5763 8.82486 16.6036 9.06154 16.6036 9.06154C16.6036 9.06154 16.6036 12.7371 16.6036 13.9623C16.6036 14.0319 16.5438 14.0651 16.5153 14.0818C16.2399 14.2438 16.0547 14.5427 16.0547 14.8853C16.0547 15.4003 16.4721 15.8177 16.9871 15.8177C17.5021 15.8177 17.9195 15.4003 17.9195 14.8853C17.9195 14.5414 17.7329 14.2415 17.4557 14.08C17.4282 14.0639 17.3705 14.0318 17.3705 13.9623Z"/>
      </g>
      <defs>
        <clipPath id="lessonCountIcon">
          <rect width="18" height="18"/>
        </clipPath>
      </defs>
    </svg>
  );
}
